import { db } from '../firebase';
import {
  collection,
  doc,
  setDoc,
  getDoc,
  serverTimestamp
} from 'firebase/firestore';

// 產生隨機短碼
function generateShortCode(length = 6): string {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

// 建立短碼對應 snapshotId
export async function createShortCodeForSnapshot(snapshotId: string): Promise<string> {
  console.log('[shortUrlService] 開始生成短碼，snapshotId:', snapshotId);
  const shortUrlsRef = collection(db, 'shortUrls');
  let shortCode = '';
  let exists = true;
  let attempts = 0;
  const maxAttempts = 5;

  // 保證短碼唯一
  while (exists && attempts < maxAttempts) {
    shortCode = generateShortCode();
    console.log('[shortUrlService] 嘗試生成短碼:', shortCode);
    const docRef = doc(shortUrlsRef, shortCode);
    const docSnap = await getDoc(docRef);
    exists = docSnap.exists();
    attempts++;
  }

  if (attempts >= maxAttempts) {
    console.error('[shortUrlService] 無法生成唯一短碼');
    throw new Error('無法生成唯一短碼');
  }

  const now = new Date();
  const expiresAt = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000); // 30天
  
  try {
    console.log('[shortUrlService] 寫入短碼到 Firestore:', shortCode);
    await setDoc(doc(shortUrlsRef, shortCode), {
      snapshotId,
      createdAt: serverTimestamp(),
      expiresAt
    });
    console.log('[shortUrlService] 短碼寫入成功');
    return shortCode;
  } catch (error) {
    console.error('[shortUrlService] 寫入短碼失敗:', error);
    throw error;
  }
}

// 由短碼查詢 snapshotId
export async function getSnapshotIdByShortCode(shortCode: string): Promise<string | null> {
  const docRef = doc(collection(db, 'shortUrls'), shortCode);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const data = docSnap.data();
    return data.snapshotId as string;
  }
  return null;
}

export async function getShortUrl(longUrl: string): Promise<string> {
  try {
    const res = await fetch(`https://tinyurl.com/api-create.php?url=${encodeURIComponent(longUrl)}`);
    if (!res.ok) throw new Error('縮短網址失敗');
    const shortUrl = await res.text();
    return shortUrl;
  } catch (err) {
    return longUrl;
  }
} 